export const GET_CREATE_CHARGE_BATCH = 'app/GET_CREATE_CHARGE_BATCH';
export const GET_CREATE_CHARGE_BATCH_SUCCESS =
  'app/GET_CREATE_CHARGE_BATCH_SUCCESS';
export const GET_CREATE_CHARGE_BATCH_FAILURE =
  'app/GET_CREATE_CHARGE_BATCH_FAILURE';
